// extracted by mini-css-extract-plugin
export default {"invisibleWithBorder":"ReposSelector-module__invisibleWithBorder--IwcUx","selected":"ReposSelector-module__selected--dfRBF"};